import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Request {
  data: any;
  sectionId: PilotId;
  fieldId: PilotId;
}

export const updateDataField = ({ data, sectionId, fieldId }: Request) => {
  return pilot.put(`document-information-fields/${fieldId}/`, {
    allow_multiple: data.allow_multiple,
    allow_new_options: data.allow_new_options,
    section_id: sectionId,
    default: data.defaultValue,
    doc_types: data.doc_types
      ? data.doc_types.map((item: any) => item.value)
      : [],
    doc_restriction: data.doc_restriction,
    field_type: data.field_type,
    help_text: data.help_text,
    is_beta: data.is_beta,
    is_smart: data.is_smart,
    is_visible: data.is_visible,
    name: data.name,
    options: data.options.map((item: any) => item.value),
    show_on_upload_form: data.show_on_upload_form,
    sort_options: data.sort_options,
  });
};
